
/**
 * Messages
 */

export const MSG_CREATING_ACCOUNT = "Creating account...";
export const MSG_REGISTER_SUCCESS = "Registeration successfull...Proceed to Login";
export const MSG_EMAIL_REQUIRED = "Email is required";
export const MSG_PASSWORD_REQUIRED = "Password is required";
export const MSG_EMAILS_MISMATCH = "Emails do not match";
export const MSG_PASSWORDS_MISMATCH = "Passwords do not match";

/**
 * Action Types
 */


export const actionTypes = {
    REGISTER_START : "REGISTER_START",
    UPDATE_REG_USERNAME : "UPDATE_REG_USERNAME",
    UPDATE_REG_PASSWORD : "UPDATE_REG_PASSWORD",
    UPDATE_CONFIRM_USERNAME : "UPDATE_CONFIRM_USERNAME",
    UPDATE_CONFIRM_PASSWORD:"UPDATE_CONFIRM_PASSWORD",
    REGISTER_SUCCESS:"REGISTER_SUCCESS",
    REGISTER_FAILED:"REGISTER_FAILED",
    REGISTER_COMPLETE : "REGISTER_COMPLETE",
    SET_SHOW_ERROR : "SET_SHOW_ERROR"
}